import { Component, EventEmitter, Input, OnInit, Output, ElementRef, ViewEncapsulation } from "@angular/core";
import { DestroyBase } from "../../../../../components/common/ng-destroy-base";
import { ValuationEventCurrenciesService } from "../../../services/valuation-event-currencies.service";
import { EventBusService } from "../../../../../services/event-bus.service";

/**
 * Handles the external rates dialog component
 */
@Component({
  selector: 'external-rates-dialog',
  templateUrl: './external-rates-dialog.component.html',
  styleUrls: ['./external-rates-dialog.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ExternalRatesDialogComponent extends DestroyBase implements OnInit {
  /**
 * ISO code of the from currency
 */
  @Input() fromCurrencyIsoCode: string;

  /**
   * ISO code of the to currency
   */
  @Input() toCurrencyIsoCode: string;

  /**
   * Event emitter for the close button click event
   */
  @Output() onCloseClicked: EventEmitter<void> = new EventEmitter();

  /**
  * Conversion date
  */
  conversionDate: Date;

  /**
   * Now timestamp
   */
  now = new Date();

  /**
* Max conversion date
*/
  maxDate: Date;

  /**
* Is datepicker ready?
*/
  isDatePickerReady = false;

  /**
   * Constructor
   * @param valuationEventCurrenciesService
   * @param elRef
   * @param eventBus
   */
  constructor(private valuationEventCurrenciesService: ValuationEventCurrenciesService, protected elRef: ElementRef, private eventBus: EventBusService) {
    super();
  }

  /**
 * Initializes the component
 */
  ngOnInit(): void {
    this.isDatePickerReady = false;
    if (new Date().getUTCHours() >= 15) {
      //If NOW is 15:00 or later IN UTC, select TODAY as default value in the date picker
      const today = new Date();
      this.maxDate = today;
      this.conversionDate = today;
    }
    else {
      const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
      this.maxDate = yesterday;
      this.conversionDate = yesterday;
    }
    setTimeout(() => {
      this.isDatePickerReady = true;
    }, 500);
  }

  /**
 * Closes the component
 */
  close(): void {
    this.onCloseClicked.emit();
  }

  /**
 * Get rate from Xignite
 */
  getRate(): void {
    this.showLoader(true);
    const date = new Date(this.conversionDate);
    const symbol = this.fromCurrencyIsoCode + this.toCurrencyIsoCode;
    this.subscriptions.add(this.valuationEventCurrenciesService.getExternalRate(symbol, date).subscribe(data => {
      this.showLoader(false);
      //https://www.xignite.com/product/forex#/DeveloperResources/request/GetHistoricalRate
      if (data && data.Outcome === 'Success') {
        this.valuationEventCurrenciesService.setExternalRate(data.Close); //Last currency exchange rate quote during the given period.
      }
      else {
        this.eventBus.broadcastEvent("openConfirmDialog", {
          success: () => {
            //Nothing. Just show OK button
          },
          customMessage: () => {
            return data.Message;
          }
        }, 'failedToRetrieveConversionRate');
      }
    }));
  }

  /**
  * Show a loading indicator
  * @param show show/hide
  */
  private showLoader(show: boolean) {
    this.eventBus.broadcastEvent('showLoader');
  }
}
